import axios from 'axios'
import { mapState as states } from "vuex"

const backendUrl = process.env.VUE_APP_BACKEND_URL

class Rest {
  constructor(httpClient, states) {
    this.idToken = null
    this.httpClient = httpClient.create()
  }

  setIdToken(idToken) {
    this.idToken = idToken
  }

  /**
   * @docme
   * @returns {Promise}
   */
  auth(idToken) {
    const self = this

    return self.httpClient.post(`${backendUrl}/auth`,
      {idToken: idToken})
      .then((r) => Promise.resolve(r.data))
  }

  // ------------------------------------------------
  // Projects.

  /**
   * Get available projects from a provider.
   *
   * @returns {Promise}
   */
  getProjects(providerId) {
    const self = this

    return self.httpClient.get(`${backendUrl}/projects`,
      {
        params: {providerId: providerId},
        headers: {
          "authorization": self.idToken,
        }
      })
      .then((r) => Promise.resolve(r.data))
  }


  // ------------------------------------------------
  // Matched projects.

  /**
   * Get matched projects
   * @param where
   * @returns {*}
   */
  getMatchedProjects(where = {}) {
    const self = this

    return self.httpClient.get(`${backendUrl}/matchedProjects`,
      {
        params: where,
        headers: {
          "authorization": self.idToken,
        }
      })
      .then((r) => Promise.resolve(r.data))
  }


  /**
   * @docme
   * @returns {Promise}
   */
  saveMatchedProject(data) {
    const self = this

    return self.httpClient.post(`${backendUrl}/matchedProject`,
      {conf: data},
      {
        headers: {
          "authorization": self.idToken,
        }
      })
      .then((r) => Promise.resolve(r.data))
  }

  /**
   * @docme
   * @returns {Promise}
   */
  deleteMatchedProject(id) {
    const self = this

    return self.httpClient.delete(`${backendUrl}/matchedProject`, {
      headers: {
        "authorization": self.idToken,
      },
      data: {
        id: id
      },
    })
  }


  // ------------------------------------------------
  // Provider.
  /**
   * @docme
   * @returns {Promise}
   */
  addProvider(data) {
    const self = this

    return self.httpClient.post(`${backendUrl}/provider`,
      {conf: data},
      {
        headers: {
          "authorization": self.idToken,
        }
      })
      .then((r) => Promise.resolve(r.data))
  }

  /**
   * Get available projects from a provider.
   *
   * @returns {Promise}
   */
  getProviders(where) {
    const self = this

    return self.httpClient.get(`${backendUrl}/provider`,
      {
        params: where,
        headers: {
          "authorization": self.idToken,
        }
      })
      .then((r) => Promise.resolve(r.data))
  }

  // ------------------------------------------------
  // Time entries.
  /**
   * @docme
   * @returns {Promise}
   */
  getTimeEntries(conf) {
    const self = this

    return self.httpClient.get(`${backendUrl}/provider/timeEntries`,
      {
        params: conf,
        headers: {
          "authorization": self.idToken,
        }
      })
      .then((r) => Promise.resolve(r.data))
  }

  /**
   * @docme
   * @returns {Promise}
   */
  registerTimeEntries(params) {
    const self = this

    return self.httpClient.post(`${backendUrl}/provider/timeEntries`,
      {providerId: params.provider, timeEntries: params.timeEntries},
      {
        headers: {
          "authorization": self.idToken,
        }
      })
  }

  /**
   * @docme
   * @returns {Promise}
   */
  unregisterTimeEntries(params) {
    const self = this

    return self.httpClient.delete(`${backendUrl}/provider/timeEntries`, {
      headers: {
        "authorization": self.idToken,
      },
      data: {providerId: params.provider, timeEntries: params.timeEntries},
    })

  }

}

export default new Rest(axios, states)
